// A component that opens the modal when the user is eligible

import React from 'react';

import { LoadableBackground } from '@confluence/loadable';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

export const EngagementModernizeModal = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ACTIVATION,
})(({
	onClose,
	onInteraction,
	source,
}: {
	onClose: () => void;
	onInteraction?: () => void;
	source: string;
}) => {
	return (
		<LazyModal
			onClose={onClose}
			onInteraction={onInteraction}
			transactional={false}
			source={source}
		/>
	);
});

const LazyModal = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-modernize-confluence-ipm-modal" */ './Modal/index.tsx'))
			.Modal,
});
